<!-- Navigation -->
<ng-container *ngIf="isScreenSmall">
    <ioteq-vertical-navigation
        style="background-color: #7F7D7C;"
        class="dark print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation?.custom"
        [opened]="false">
        <!-- Navigation header hook -->
        <ng-container ioteqVerticalNavigationContentHeader>
            <!-- Logo -->
            <div class="flex items-center h-20 pt-6 px-8">
                <img *ngIf="user.organization === 'profrac' || user.organization === 'f' || user.organization === 'ioteq'"
                    [routerLink]="['/trailer-systems/list']"
                    class="w-24"
                    src="assets/images/logo/25-FTK-19387 - PWRTEK Logo FINAL.png"
                    alt="Logo image">
            </div>
        </ng-container>
    </ioteq-vertical-navigation>
</ng-container>

<!-- Wrapper -->
<div class="flex flex-col flex-auto items-center w-full min-w-0 dark:bg-card relative" style="background-color: #7F7D7C;">
    <display-bulletins style="min-height: 40px !important; position: fixed; z-index: 1000;"></display-bulletins>
    <!-- Header -->
    <div class="relative flex justify-center w-full overflow-hidden z-49 print:hidden" style="background-color: #7F7D7C;">
        <div class="max-w-360 w-full sm:m-8 sm:mb-0 md:mt-12 md:mx-8 md:pt-4 md:pb-3 sm:rounded-t-xl sm:shadow-2xl overflow-hidden" style="background-color: #828994;">
            <!-- Top bar -->
            <div class="relative flex flex-auto flex-0 items-center h-16 px-4 md:px-6" style="background-color: #828994;">
                <!-- Logo -->
                <ng-container *ngIf="!isScreenSmall">
                    <div class="flex items-center mx-2">
                        <!-- Light version PF -->
                        <img
                            *ngIf="user.organization === 'profrac' || user.organization === 'f' || user.organization === 'ioteq'"
                            [routerLink]= "['./trailer-systems/' + send]"
                            class="w-40 dark:hidden"
                            src="assets/images/logo/25-FTK-19387 - PWRTEK Logo FINAL.png"
                            alt="Logo image"
                        >
                        <!-- Dark version PF-->
                        <img
                            *ngIf="user.organization === 'profrac' || user.organization === 'f' || user.organization === 'ioteq'"
                            [routerLink]= "['./trailer-systems/' + send]"
                            class="hidden dark:flex w-40"
                            src="assets/images/logo/25-FTK-19387 - PWRTEK Logo FINAL.png"
                            alt="Logo image"
                        >

                        <!-- Light version CLIENT-->
                        <h1
                            *ngIf="user.organization !== 'profrac' && user.organization !== 'f' && user.organization !== 'ioteq'"
                            [routerLink]= "['./trailer-systems/' + send]"
                            class="text-5xl font-bold dark:hidden text-white"
                        >{{orgTitle.name}}</h1>
                        <!-- Dark version CLIENT -->
                        <h1
                            *ngIf="user.organization !== 'profrac' && user.organization !== 'f' && user.organization !== 'ioteq'"
                            [routerLink]= "['./trailer-systems/' + send]"
                            class="hidden text-5xl font-bold text-white"
                        >{{orgTitle.name}}</h1>
                    </div>
                    <!-- TOGGLE DURING APP UPDATES-->
                    <!-- <div class="font-bold  text-xl border-b" >UPDATE IN PROGRESS</div> -->

                </ng-container>
                <!-- Navigation toggle button -->
                <ng-container *ngIf="isScreenSmall">
                    <!-- <button
                        mat-icon-button
                        (click)="toggleNavigation('mainNavigation')">
                        <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
                    </button> -->
                    <img
                        *ngIf="user.organization === 'profrac' || user.organization === 'f' || user.organization === 'ioteq'"
                        [routerLink]= "['./trailer-systems/' + send]"
                        class="dark:flex w-30"
                        src="assets/images/logo/25-FTK-19387 - PWRTEK Logo FINAL.png"
                        alt="Logo image"
                    >
                    <h1
                        *ngIf="user.organization !== 'profrac' && user.organization !== 'f' && user.organization !== 'ioteq'"
                        [routerLink]= "['./trailer-systems/' + send]"
                        class="sm:text-4xl text-3xl font-bold text-white"
                    >{{orgTitle.name}}</h1>
                </ng-container>
                <!-- Components -->
                <div class="flex items-center pl-2 ml-auto space-x-2">
                    <!--<languages></languages>-->
                    <map-list-slider></map-list-slider>
                    <ioteq-fullscreen *ngIf="!isScreenSmall"></ioteq-fullscreen>
                    <!--<search [appearance]="'bar'"></search>-->
                    <!--<shortcuts></shortcuts>-->
                    <!--<messages></messages>-->
                    <!--<notifications></notifications>-->
                    <user></user>
                </div>
            </div>
            <!-- Bottom bar -->
            <ng-container *ngIf="!isScreenSmall">
                <!-- <div class="relative flex flex-auto flex-0 items-center h-16 px-4" style="background: #d3d3d35c;">
                    <ioteq-horizontal-navigation
                        [name]="'mainNavigation'"
                        [navigation]="navigation?.custom">
                    </ioteq-horizontal-navigation>
                </div> -->
            </ng-container>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto justify-center w-full sm:px-8">
        <div class="flex flex-col flex-auto w-full sm:max-w-360 sm:shadow-xl sm:overflow-hidden bg-default">
            <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
                 Otherwise, layout changes won't be registered and the view won't be updated! -->
            <router-outlet *ngIf="true"></router-outlet>
        </div>
    </div>

    <!-- Footer -->
    <div class="sticky bottom-0 flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <!--<span class="font-medium text-secondary">iO-TEQ &copy; {{currentYear}}</span>-->

        <div fxLayout="row" fxLayoutAlign.gt-xs="space-between center" fxFlex>

            <div class="w-15">
                <img src="assets/images/logo/JP3_ALL_JP3MainGradientNoTagline.png">
            </div>

            <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
                <div class="w-7">
                    <!-- <img src="assets/images/logo/f3_logo_black.png"> -->
                </div>

            </div>

        </div>
    </div>

</div>